import { render, staticRenderFns } from "./DxAnnualBudgets.vue?vue&type=template&id=1806fbf2&"
import script from "./DxAnnualBudgets.vue?vue&type=script&lang=js&"
export * from "./DxAnnualBudgets.vue?vue&type=script&lang=js&"
import style0 from "./DxAnnualBudgets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports